// Алёрты для ТМ и РМ: отпуска, покрытие, данные СВ, вакансии, качество планирования.
// Чистые функции — без запросов к БД. Данные приходят из TmPage / RmPage.

const DAY = 86400000;

// Пороги (по умолчанию, согласованы)
export const TH = {
  vacWarn: 3,        // заявка на отпуск ждёт дольше N дней — жёлтый
  vacBad: 5,         // ... дольше N дней — красный
  vacancyWarn: 14,   // вакансия дольше N дней — жёлтый
  vacancyBad: 30,    // ... красный
  seenWarn: 3,       // СВ не заходил N дней — жёлтый
  seenBad: 7,        // ... красный
  visitsWarn: 5, visitsBad: 10,   // отклонение визитов, %
  slWarn: 3, slBad: 5,            // отклонение SL, п.п.
  accWarn: 90, accBad: 80,        // точность планирования, % (ниже — жёлтый / красный)
};

export const CAT_LABEL = {
  vac: 'Заявки отпусков',
  cover: 'Дни без перекрытий',
  rec: 'Заявки подбора',
  nofc: 'Нет статуса или прогноза',
  tabel: 'Нет статуса или прогноза',
  data: 'Не заходил в систему',
  vacancy: 'Вакансии',
  plan: 'Планирование',
};
export const CAT_ORDER = ['Заявки отпусков', 'Дни без перекрытий', 'Заявки подбора', 'Нет статуса или прогноза', 'Не заходил в систему', 'Вакансии', 'Планирование'];

export function mskToday() {
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Moscow' });
}
const toUtc = (s) => Date.UTC(+s.slice(0, 4), +s.slice(5, 7) - 1, +s.slice(8, 10));
export function addDays(s, n) { return new Date(toUtc(s) + n * DAY).toISOString().slice(0, 10); }
export function diffDays(a, b) { return Math.round((toUtc(a) - toUtc(b)) / DAY); }
export const fmtDM = (s) => `${s.slice(8, 10)}.${s.slice(5, 7)}`;

export function dayWord(n) {
  const a = Math.abs(n) % 100, b = a % 10;
  if (a > 10 && a < 20) return 'дней';
  if (b === 1) return 'день';
  if (b >= 2 && b <= 4) return 'дня';
  return 'дней';
}

function mrcOf(route) {
  const m = route?.merchandisers;
  return Array.isArray(m) ? m[0] : m;
}
function routeLabel(route) {
  const m = mrcOf(route);
  return (route.is_vacancy || !m?.full_name) ? `Вакансия ${route.internal_code}` : m.full_name;
}

const UNCOVERED = /^(БЛ|ОТ)[-−]$/;

/**
 * svGroups: [{ sv, routes, statuses }], vacations: vacation_plans[],
 * lastSeen: { [users.id]: ISO }, weeks/weekNums как в страницах.
 * Возвращает [{ id, cat, level, title, detail, svId, svName, tmId, tmName, goto }].
 * goto: { svId, tab: 'tabel'|'vac', routeId?, routeIds?, date?, vacId? , top?: номер верхней вкладки }
 */
export function buildAlerts({ svGroups, vacations = [], weeks = {}, weekNums = [], lastSeen = {}, tmId = null, tmName = '', today = mskToday(), nowMs = Date.now() }) {
  const out = [];
  const allDates = new Set(weekNums.flatMap(w => (weeks[w]?.days || []).map(d => d.date)));
  const curWeek = weekNums.find(w => (weeks[w]?.days || []).some(d => d.date === today));
  const weekDays = curWeek ? weeks[curWeek].days.map(d => d.date).filter(d => d >= today) : [];
  const tomorrow = addDays(today, 1);
  const yesterday = addDays(today, -1);
  const routeGroup = {};
  svGroups.forEach(g => g.routes.forEach(r => { routeGroup[r.id] = g; }));
  const meta = (g) => ({ svId: g.sv.id, svName: g.sv.full_name, tmId, tmName });

  // 1. Заявки на отпуск, которые долго ждут подтверждения
  vacations.filter(v => v.status === 'pending').forEach(v => {
    const g = routeGroup[v.route_id];
    const since = v.updated_at || v.created_at;
    if (!g || !since) return;
    const age = Math.floor((nowMs - Date.parse(since)) / DAY);
    if (age <= TH.vacWarn) return;
    const route = g.routes.find(r => r.id === v.route_id);
    out.push({
      id: `vac:${v.id}`, cat: 'vac', level: age > TH.vacBad ? 'bad' : 'warn',
      title: `Заявка на отпуск ждёт ${age} ${dayWord(age)}`,
      detail: `${routeLabel(route)} · ${fmtDM(v.date_from)}–${fmtDM(v.date_to)} · ${g.sv.full_name}`,
      sortKey: -age, ...meta(g),
      goto: { svId: g.sv.id, tab: 'vac', routeId: v.route_id, vacId: v.id },
    });
  });

  svGroups.forEach(g => {
    const work = g.routes.filter(r => !r.is_vacancy);

    // 2. БЛ / ОТ без перекрытия: сегодня, завтра и до конца недели
    work.forEach(r => {
      const days = weekDays.filter(d => UNCOVERED.test(g.statuses?.[r.id]?.[d] || ''));
      if (!days.length) return;
      const first = days[0];
      const kinds = Array.from(new Set(days.map(d => (g.statuses[r.id][d] || '').slice(0, 2)))).join('/');
      const when = first === today ? 'сегодня' : first === tomorrow ? 'завтра' : `с ${fmtDM(first)}`;
      out.push({
        id: `cover:${r.id}`, cat: 'cover', level: first <= tomorrow ? 'bad' : 'warn',
        title: `${kinds} без перекрытия ${when}`,
        detail: `${routeLabel(r)} · ${r.internal_code}${days.length > 1 ? ` · ${days.length} ${dayWord(days.length)}` : ''} · ${g.sv.full_name}`,
        sortKey: first, ...meta(g),
        goto: { svId: g.sv.id, tab: 'tabel', routeId: r.id, routeIds: [r.id], date: first },
      });
    });

    const svVacant = String(g.sv.full_name || '').startsWith('Вакансия_');

    // 3. Нет статусов за вчера (для места без СВ не считаем)
    if (!svVacant && work.length && allDates.has(yesterday)) {
      const missing = work.filter(r => !g.statuses?.[r.id]?.[yesterday]);
      if (missing.length) {
        out.push({
          id: `nostat:${g.sv.id}`, cat: 'tabel', level: missing.length * 2 >= work.length ? 'bad' : 'warn',
          title: `Нет статусов за вчера (${fmtDM(yesterday)})`,
          detail: `${g.sv.full_name} · ${missing.length} из ${work.length} маршрутов без статуса`,
          sortKey: -missing.length, ...meta(g),
          goto: { svId: g.sv.id, tab: 'tabel', routeId: missing[0].id, routeIds: missing.map(r => r.id), date: yesterday },
        });
      }
    }

    // 4. СВ давно не заходил в систему
    const seen = g.sv.user_id ? lastSeen[g.sv.user_id] : null;
    if (seen && !svVacant) {
      const days = Math.floor((nowMs - Date.parse(seen)) / DAY);
      if (days >= TH.seenWarn) {
        out.push({
          id: `seen:${g.sv.id}`, cat: 'data', level: days >= TH.seenBad ? 'bad' : 'warn',
          title: `Не заходил в систему ${days} ${dayWord(days)}`,
          detail: `${g.sv.full_name} · последний вход ${fmtDM(String(seen).slice(0, 10))}`,
          sortKey: -days, ...meta(g),
          goto: { svId: g.sv.id, tab: 'tabel' },
        });
      }
    }

    // 5. Вакансии дольше N дней
    g.routes.filter(r => r.is_vacancy && r.vacant_since).forEach(r => {
      const days = diffDays(today, String(r.vacant_since).slice(0, 10));
      if (days <= TH.vacancyWarn) return;
      out.push({
        id: `vacancy:${r.id}`, cat: 'vacancy', level: days > TH.vacancyBad ? 'bad' : 'warn',
        title: `Вакансия ${days} ${dayWord(days)}`,
        detail: `${r.internal_code} · ${g.sv.full_name}`,
        sortKey: -days, ...meta(g),
        goto: { svId: g.sv.id, tab: 'tabel', routeId: r.id, routeIds: [r.id] },
      });
    });
  });

  return sortAlerts(out);
}

export function sortAlerts(list) {
  const lv = { bad: 0, warn: 1, info: 2 };
  return [...list].sort((a, b) => (lv[a.level] - lv[b.level]) || ((a.sortKey ?? 0) < (b.sortKey ?? 0) ? -1 : (a.sortKey ?? 0) > (b.sortKey ?? 0) ? 1 : 0));
}

export function groupAlerts(list) {
  const map = {};
  list.forEach(a => { (map[CAT_LABEL[a.cat]] ||= []).push(a); });
  return CAT_ORDER.filter(k => map[k]).map(k => ({ label: k, items: map[k] }));
}

// ── КАЧЕСТВО ПЛАНИРОВАНИЯ ───────────────────────────────────────────────────
// План = снимок «заморозки» (rwFrozen), факт = живые данные (rwLive).
// Недели без факта (BI ещё не загружен) и незавершённые недели не считаем.

export function completedWeeks(weeks, weekNums, today = mskToday()) {
  return weekNums.filter(w => weeks[w]?.date_to && String(weeks[w].date_to).slice(0, 10) < today);
}

export function calcQuality(svGroups, weeksSel, rwFrozen, rwLive, forecasts) {
  let plan = 0, fact = 0, ordLive = 0, fw = 0, fs = 0, used = 0, derived = false;
  weeksSel.forEach(w => {
    let wFact = 0;
    svGroups.forEach(g => g.routes.forEach(r => { wFact += rwLive[r.id]?.[w]?.fact || 0; }));
    if (wFact <= 0) return;
    used++;
    svGroups.forEach(g => {
      let sPlan = 0, sOrdF = 0;
      g.routes.forEach(r => {
        const f = rwFrozen[r.id]?.[w], l = rwLive[r.id]?.[w];
        sPlan += f?.plan || 0; sOrdF += f?.ord || 0;
        plan += f?.plan || 0; fact += l?.fact || 0; ordLive += l?.ord || 0;
      });
      let pf = forecasts?.[g.sv.id]?.[w];
      if (pf == null && sOrdF > 0) { pf = sPlan / sOrdF * 100; derived = true; }
      if (pf != null && sOrdF > 0) { fw += pf * sOrdF; fs += sOrdF; }
    });
  });
  if (!used || plan <= 0) return null;
  const dv = (fact - plan) / plan * 100;
  const fSl = fs > 0 ? fw / fs : null;
  const aSl = ordLive > 0 ? fact / ordLive * 100 : null;
  const dSl = (fSl != null && aSl != null) ? aSl - fSl : null;
  const acc = Math.max(0, Math.round(100 - Math.abs(fact - plan) / plan * 100));
  return { plan, fact, dv, fSl, aSl, dSl, acc, derived, weeksUsed: used };
}

export function levelDv(v) { const a = Math.abs(v); return a >= TH.visitsBad ? 'r' : a >= TH.visitsWarn ? 'y' : 'g'; }
export function levelSl(v) { const a = Math.abs(v); return a >= TH.slBad ? 'r' : a >= TH.slWarn ? 'y' : 'g'; }
export function levelAcc(v) { return v < TH.accBad ? 'r' : v < TH.accWarn ? 'y' : 'g'; }

// Алёрт «Планирование»: точность < 80% две последние недели с фактом подряд
export function buildPlanAlerts({ svGroups, weeks, weekNums, rwFrozen, rwLive, forecasts, tmId = null, tmName = '', today = mskToday() }) {
  const done = completedWeeks(weeks, weekNums, today);
  const out = [];
  svGroups.forEach(g => {
    const q = done.map(w => ({ w, q: calcQuality([g], [w], rwFrozen, rwLive, forecasts) })).filter(x => x.q);
    if (q.length < 2) return;
    const [a, b] = q.slice(-2);
    if (a.q.acc < TH.accBad && b.q.acc < TH.accBad) {
      out.push({
        id: `plan:${g.sv.id}`, cat: 'plan', level: b.q.acc < 70 ? 'bad' : 'warn',
        title: `Точность планирования ниже ${TH.accBad}% две недели подряд`,
        detail: `${g.sv.full_name} · W${a.w} ${a.q.acc}% · W${b.w} ${b.q.acc}%`,
        sortKey: b.q.acc, svId: g.sv.id, svName: g.sv.full_name, tmId, tmName,
        goto: { svId: g.sv.id, top: 'forecast' },
      });
    }
  });
  return out;
}

// Идущая неделя: сравниваем план и факт только по прошедшим дням (до вчера включительно)
export function partialInfo(weeks, weekNums, today = mskToday()) {
  const until = addDays(today, -1);
  const w = weekNums.find(n => weeks[n]?.date_from && String(weeks[n].date_from).slice(0, 10) <= today && String(weeks[n].date_to).slice(0, 10) >= today);
  if (w == null || until < String(weeks[w].date_from).slice(0, 10)) return null;
  return { week: w, until };
}

// Подменяет данные недели week в свёртке rw (маршрут -> неделя) данными «на вчера»
export function mergePartial(rw, partial, week) {
  if (!partial) return rw;
  const out = {};
  Object.keys(rw).forEach(r => { const { [week]: _drop, ...rest } = rw[r]; out[r] = rest; });
  Object.keys(partial).forEach(r => { out[r] = { ...(out[r] || {}), ...(partial[r][week] ? { [week]: partial[r][week] } : {}) }; });
  return out;
}


// Маршрут «без внесения»: в табеле нет НИ ОДНОГО статуса (любой код — рабочий, ОТ, вакансия — считается внесением)
// ни за месяц, ни (со вторника) за текущую неделю. Вакантный маршрут/СВ и маршруты с отпуском не считаем.
export function routeNoEntry(statusesOfRoute, curWeekObj, today = mskToday()) {
  const keys = Object.keys(statusesOfRoute || {});
  if (!keys.length) return true;
  if (curWeekObj && today > String(curWeekObj.date_from).slice(0, 10)) {
    const a = String(curWeekObj.date_from).slice(0, 10), b = String(curWeekObj.date_to).slice(0, 10);
    return !keys.some(d => d >= a && d <= b);
  }
  return false;
}


// Алёрт «Нет прогноза»: по каждому СВ — маршруты, где (а) за месяц есть заказ, но плана нет,
// (б) на текущей неделе есть заказ, но плана нет, (в) в табеле вообще нет внесения (см. routeNoEntry) — только если за месяц есть заказ.
export function buildNoForecastAlerts({ svGroups, weeks = {}, weekNums = [], rweeks = {}, vacations = [], tmId = null, tmName = '', today = mskToday() }) {
  const out = [];
  const curWeek = weekNums.find(w => weeks[w] && String(weeks[w].date_from).slice(0, 10) <= today && today <= String(weeks[w].date_to).slice(0, 10)) ?? null;
  svGroups.forEach(g => {
    if (String(g.sv.full_name || '').startsWith('Вакансия_')) return;
    const bad = [];
    const kinds = { month: 0, week: 0, empty: 0 };
    const work = g.routes.filter(r => !r.is_vacancy);
    work.forEach(r => {
      let plan = 0, ord = 0;
      weekNums.forEach(w => { const c = rweeks[r.id]?.[w]; if (c) { plan += c.plan || 0; ord += c.ord || 0; } });
      const cw = curWeek != null ? rweeks[r.id]?.[curWeek] : null;
      const curZero = !!cw && (cw.ord || 0) > 0 && (cw.plan || 0) === 0;
      const noEntry = ord > 0 && routeNoEntry(g.statuses?.[r.id], curWeek != null ? weeks[curWeek] : null, today) && !vacations.some(v => v.route_id === r.id);
      if (noEntry) { kinds.empty++; bad.push(r); }
      else if (curZero) { kinds.week++; bad.push(r); }
      else if (ord > 0 && plan === 0) { kinds.month++; bad.push(r); }
    });
    if (!bad.length) return;
    const parts = [];
    if (kinds.empty) parts.push(`${kinds.empty} без внесения в табель`);
    if (kinds.week) parts.push(`${kinds.week} без плана на текущую неделю`);
    if (kinds.month) parts.push(`${kinds.month} без плана на месяц`);
    out.push({
      id: `nofc:${g.sv.id}`, cat: 'nofc', level: bad.length * 2 >= work.length ? 'bad' : 'warn',
      title: `Нет прогноза: ${bad.length} из ${work.length} маршрутов`,
      detail: `${g.sv.full_name} · ${parts.join(' · ')}`,
      sortKey: -bad.length, svId: g.sv.id, svName: g.sv.full_name, tmId, tmName,
      goto: { svId: g.sv.id, tab: 'tabel', routeId: bad[0].id, routeIds: bad.map(r => r.id) },
    });
  });
  return out;
}


// Алёрты «Заявки подбора» (данные из файла в админке). Три признака, везде одна пара знаков: ✗ плохо / ✓ хорошо.
//  1) ✗ подбор стоит — заявка приостановлена;
//  2) ✗ заявка зависла — на одном этапе дольше TH.recWarn / TH.recBad дней (кроме этапа «Принят»);
//  3) ✗ заявка открыта при ✓ занятом маршруте — маршрут не вакантный, а заявка не закрыта (кроме «Принят»).
export function buildRecruitAlerts({ svGroups, recruiting = {}, tmId = null, tmName = '', today = mskToday() }) {
  const WARN = 14, BAD = 30;
  const out = [];
  svGroups.forEach(g => {
    if (String(g.sv.full_name || '').startsWith('Вакансия_')) return;
    const pause = [], old = [], busy = [];
    const all = [...g.routes.map(r => ({ r, pm: false })), ...(g.pmRoutes || []).map(r => ({ r, pm: true }))];
    all.forEach(({ r, pm }) => (recruiting[r.id] || []).forEach(q => {
      const rr = { r, q };
      if (q.status === 'Приостановлена') pause.push(rr);
      if (q.stage !== 'Принят') {
        const since = q.stage_since ? String(q.stage_since).slice(0, 10) : (q.opened_at || null);
        const days = since ? diffDays(today, since) : 0;
        if (q.status !== 'Приостановлена' && days >= WARN) old.push({ ...rr, days });
        if (!r.is_vacancy && !pm) busy.push(rr);
      }
    }));
    const meta = { svId: g.sv.id, svName: g.sv.full_name, tmId, tmName };
    const go = (list) => ({ svId: g.sv.id, tab: 'tabel', routeId: list[0].r.id, routeIds: list.map(x => x.r.id) });
    const word = (n) => (n % 10 === 1 && n % 100 !== 11) ? 'заявка' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) ? 'заявки' : 'заявок';
    if (pause.length) {
      const reasons = [...new Set(pause.map(x => x.q.suspend_reason).filter(Boolean))].slice(0, 2).join('; ');
      out.push({ id: `rec-pause:${g.sv.id}`, cat: 'rec', level: 'warn', title: `✗ Подбор стоит: ${pause.length} ${word(pause.length)} приостановлено`,
        detail: `${g.sv.full_name}${reasons ? ' · ' + reasons : ''}`, sortKey: -pause.length, ...meta, goto: go(pause) });
    }
    if (old.length) {
      const max = Math.max(...old.map(x => x.days));
      out.push({ id: `rec-old:${g.sv.id}`, cat: 'rec', level: max >= BAD ? 'bad' : 'warn', title: `✗ Заявка зависла: ${old.length} ${word(old.length)}, до ${max} дн. на одном этапе`,
        detail: `${g.sv.full_name} · ${[...new Set(old.map(x => x.q.stage).filter(Boolean))].slice(0, 3).join(', ')}`, sortKey: -max, ...meta, goto: go(old) });
    }
    if (busy.length) {
      out.push({ id: `rec-busy:${g.sv.id}`, cat: 'rec', level: 'warn', title: `✗ Заявка открыта, ✓ маршрут занят: ${busy.length} ${word(busy.length)}`,
        detail: `${g.sv.full_name} · закройте заявку или освободите маршрут`, sortKey: -busy.length, ...meta, goto: go(busy) });
    }
  });
  return out;
}
